export const MAILING_ROUTE_NAMES = {
    LIST: "MailingList",
    CREATE: "MailingAdd",
    EDIT: "MailingEdit",
    STATS: "MailingStats",
    ONBOARDING: "MailingOnboarding",
    COHORTS: "MailingCohorts",
};
